'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/** Figma "Input" → Label row: DLZ/Body/S Medium, required "*" in text/brand 2 px after the text. */
const labelVariants = cva(
  'dlz-body-s-medium text-[#0F1012] peer-disabled:cursor-not-allowed peer-disabled:text-[#9096A0]',
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> & {
      required?: boolean;
    }
>(({ className, required, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props}>
    {props.children}
    {required && (
      <span aria-hidden="true" className="ml-0.5 text-[#D7191F]">
        *
      </span>
    )}
  </LabelPrimitive.Root>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
